import React, { useEffect } from 'react';
import { getUser } from '../../../service/user';
import { useQuery } from 'react-query';
import styles from './UserProfile.module.scss'
import Icon, { Icons } from '../../../components/Icon/Icon';
import { main_color } from '../../../styles/_variables';
import { useUserStore } from '../../../store/useUser';
import { getLastUserBook, getPagesAndBooksCountByUserId } from '../../../service/bookcase';
import { CustomBook } from '../../../components/Book/Book';
import Profile from './Profile';
import { NavLink } from 'react-router-dom';
import { getUserIdByPathname } from '../../../utils/user';
import useHeader from '../../../hooks/useHeader';
import { useFetchGetUser, useFetchGetUserGenres } from '../../../service/fetchs';
import Modal from '../../../components/Modal/Modal';
import AddUserGenres from '../../../container/Modal/Modals/RegisterModal/AddUserGenres';

type ItemProps = {
  name: string;
  data: any[];
  icon: Icons;
  to: string;
}

const Item = ({name, data, icon, to}:ItemProps) =>{
  return (
    <section className={styles.item}>
      <Icon icon={icon} color={main_color}/>
      <NavLink to={to}>
        <h1><strong>{name}</strong></h1>
      </NavLink>
      {data.map(item => <div>{item}</div>)}
    </section>
  )
}

const UserProfile = () => {
  const profile = useUserStore(state => state.profile);
  const userIdAutheticated = useUserStore(state => state.id);

  const userId = getUserIdByPathname()

  const {data: user} = useFetchGetUser(userId);
  const {data: userGenres, isFetching, isFetched} = useFetchGetUserGenres(userId);

  const {data:count, isFetching: isFetchingPages} = useQuery(
    ['pages'],
    () => getPagesAndBooksCountByUserId(userId),
    {refetchOnMount: 'always', staleTime: 0, refetchOnWindowFocus: false},
  );

  const {data:lastBook, isFetching: isFetchingBook} = useQuery(
    ['last-book'],
    () => getLastUserBook(userId),
    {refetchOnMount: 'always', staleTime: 0, refetchOnWindowFocus: false},
  );

  useHeader({ header: user?.fullname, subheader: `${count?.books} livros` });

  const shouldShowSecretsItems = profile === 'Clubista' && userId === userIdAutheticated
  
  const shouldShowModal = !isFetching 

  return (
      <div className={styles.container}>
        <Profile 
          description={user?.description || ''} 
          name={user?.fullname || ''}
          imgSrc={user?.pathPhoto || ''}
          genres={userGenres || []}
          booksReaded={count?.books || 0}
          pagesReaded={count?.pages || 0}
          />
        <section>
        <Item 
          name="Estante"
          icon={'bookcase'}
          data={[]}
          to={`/user/${userId}/bookcase`}
          />
        {
          shouldShowSecretsItems && <Item 
            name="Encontros"
            icon={'calendar'}
            data={[]}
            to={`/user/meets`}
            />
          }
        <Item 
          name="Clubes" 
          icon={'group'}
          data={[]}
          to={`/user/${userId}/clubs`}
          />
        {
          shouldShowSecretsItems && <Item 
          name="Votações" 
          icon={'votes'} 
          data={[]}
          to={`/user/votes`}
          />
        }
        {
          shouldShowSecretsItems && <Item 
          name="Fóruns" 
          icon={'forum'}
          data={[]}
          to={`/user/forums`}
          />
        }
        </section>
        {
          lastBook && 
            <section>
              <header>
                <h1 >Último livro lido</h1>
              </header>
              <CustomBook
                bookId={lastBook?.bookId}
                key={lastBook?.bookId}
              />
            </section>
          }
          {/* <Modal
            open={shouldShowModal && !userGenres?.length}
          >
            {()=> <AddUserGenres />}
          </Modal> */}
      </div>
  )
}

export default UserProfile;